import type { ReactNode } from 'react';

import { cls } from '@/utils/cls';

export type CommunicationDetailsBoxProps = {
  className?: string;
  children: ReactNode;
};

export function CommunicationDetailsBox({
  className,
  children,
}: CommunicationDetailsBoxProps) {
  return (
    <div className={cls('rounded-lg border bg-white p-4', className)}>
      {children}
    </div>
  );
}
